import React from "react";
import "../../Styles/Robot/Robot.css";

function Robot({ texts = [], handleRobotText }) {
  const animate = (e) => {
    const eyes = document.querySelectorAll(".robot-eye");
    eyes.forEach((eye) => {
      let x = eye.getBoundingClientRect().left + eye.clientWidth / 2;
      let y = eye.getBoundingClientRect().top + eye.clientHeight / 2;
      let r = Math.atan2(e.pageX - x, e.pageY - y);
      let root = r * (180 / Math.PI) * -1 + 0;
      eye.style.transform = `rotate(${root}deg)`;
    });
  };
  React.useEffect(() => {
    window.addEventListener("mousemove", animate);

    handleRobotText("Hi...👋");
    setTimeout(() => {
      handleRobotText("My name is Jarvis!");
    }, 2000);
    setTimeout(() => {
      handleRobotText("Nice to meet you...😃");
    }, 4000);
    return () => {
      window.removeEventListener("mousemove", animate);
    };
  }, []);
  return (
    <div className="robot">
      <img
        src={process.env.PUBLIC_URL + "/images/Robot.png"}
        alt="Robot"
        onMouseEnter={() => handleRobotText("He he.. stop ticking me..😆")}
      />
      {texts.length ? (
        <div className="robot-text">
          {texts.map((el) => (
            <p>{el}</p>
          ))}
        </div>
      ) : null}
      <div className="robot-face">
        <div className="robot-eye"></div>
        <div className="robot-eye"></div>
      </div>
    </div>
  );
}

export default Robot;
